"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var item_1 = require("common/domain/item");
var effects_1 = require("redux-saga/effects");
var Immutable = require("seamless-immutable");
var typescript_fsa_1 = require("typescript-fsa");
var typescript_fsa_reducers_1 = require("typescript-fsa-reducers");
var message = require("./message");
var utils_1 = require("./utils");
function createItemsDuck(reducerName, repository, initialize, options) {
    if (options === void 0) { options = {}; }
    options = Object.assign({
        onToggleTaskState: function (item) { return item; },
        partialInitialState: {},
    }, options);
    var factory = typescript_fsa_1.default(reducerName.toUpperCase());
    var addToTodoList = factory("ADD_TO_TODO_LIST");
    var createItem = factory("CREATE_ITEM");
    var getItems = factory.async("GET_ITEMS");
    var getTrendingItems = factory.async("GET_TRENDING_ITEMS");
    var removeItem = factory("REMOVE_ITEM");
    var setCurrentItem = factory("SET_CURRENT_ITEM");
    var setItems = factory("SET_ITEMS");
    var toggleItemState = factory("TOGGLE_ITEM_STATE");
    var initialState = Immutable(__assign({}, options.partialInitialState, { currentItem: null, doneItems: [], todoItems: [] }));
    function selectState() {
        return effects_1.select(function (state) { return state[reducerName]; });
    }
    return {
        actionCreatorFactory: factory,
        actionCreators: {
            addToTodoList: addToTodoList,
            createItem: createItem,
            getItems: function () { return getItems.started(null); },
            getTrendingItems: function () { return getTrendingItems.started(null); },
            removeItem: removeItem,
            setCurrentItem: setCurrentItem,
            setItems: function (items, done) { return setItems({ done: done, items: items }); },
            toggleItemState: toggleItemState,
        },
        getItemsActionCreators: getItems,
        initialState: initialState,
        reducer: typescript_fsa_reducers_1.reducerWithInitialState(initialState)
            .case(getItems.done, function (state, _a) {
            var result = _a.result;
            return state.merge(result);
        })
            .case(getTrendingItems.done, function (state, _a) {
            var result = _a.result;
            return state.merge({ trendingItems: result });
        })
            .case(setCurrentItem, function (state, currentItem) { return state.merge({ currentItem: currentItem }); })
            .case(setItems, function (state, _a) {
            var done = _a.done, items = _a.items;
            return state.merge(done ? { doneItems: items } : { todoItems: items });
        }),
        sagas: [
            utils_1.takeEvery(addToTodoList, function _(item) {
                var _a, _b, _c, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            _a = effects_1.put;
                            _b = setItems;
                            _c = {
                                done: false
                            };
                            _d = item_1.addItemToItems;
                            return [4 /*yield*/, selectState()];
                        case 1: return [4 /*yield*/, _a.apply(void 0, [_b.apply(void 0, [(_c.items = _d.apply(void 0, [(_e.sent()).todoItems, item]),
                                        _c)])])];
                        case 2:
                            _e.sent();
                            return [4 /*yield*/, effects_1.put(setCurrentItem(item))];
                        case 3:
                            _e.sent();
                            return [2 /*return*/];
                    }
                });
            }),
            utils_1.takeEvery(createItem, function _(itemSource) {
                var item, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 5, , 7]);
                            return [4 /*yield*/, effects_1.put(message.actionCreators.sendMessage("Creating an item...", { temporary: false }))];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, effects_1.call(initialize, itemSource)];
                        case 2:
                            item = _a.sent();
                            if (!item.name) {
                                throw new Error("Invalid item is detected: " + item.name);
                            }
                            return [4 /*yield*/, effects_1.put(addToTodoList(item))];
                        case 3:
                            _a.sent();
                            return [4 /*yield*/, effects_1.put(message.actionCreators.clearMessage())];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 7];
                        case 5:
                            error_1 = _a.sent();
                            return [4 /*yield*/, effects_1.put(message.actionCreators.sendMessage("Failed to create an item.", { error: true }))];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 7];
                        case 7: return [2 /*return*/];
                    }
                });
            }),
            utils_1.takeEvery(getItems.started, function _() {
                var _a, _b, _c, _d, error_2;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            _e.trys.push([0, 3, , 5]);
                            _a = effects_1.put;
                            _c = (_b = getItems).done;
                            _d = {
                                params: null
                            };
                            return [4 /*yield*/, effects_1.all({
                                    doneItems: effects_1.call(repository.state(true).get),
                                    todoItems: effects_1.call(repository.state(false).get),
                                })];
                        case 1: return [4 /*yield*/, _a.apply(void 0, [_c.apply(_b, [(_d.result = _e.sent(),
                                        _d)])])];
                        case 2:
                            _e.sent();
                            return [3 /*break*/, 5];
                        case 3:
                            error_2 = _e.sent();
                            return [4 /*yield*/, effects_1.put(message.actionCreators.sendMessage("Couldn't sync data.", { error: true }))];
                        case 4:
                            _e.sent();
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            }),
            utils_1.takeEvery(getTrendingItems.started, function _() {
                var _a, _b, _c, _d, error_3;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            _e.trys.push([0, 3, , 5]);
                            _a = effects_1.put;
                            _c = (_b = getTrendingItems).done;
                            _d = {
                                params: null
                            };
                            return [4 /*yield*/, effects_1.call(options.getTrendingItems)];
                        case 1: return [4 /*yield*/, _a.apply(void 0, [_c.apply(_b, [(_d.result = _e.sent(),
                                        _d)])])];
                        case 2:
                            _e.sent();
                            return [3 /*break*/, 5];
                        case 3:
                            error_3 = _e.sent();
                            return [4 /*yield*/, effects_1.put(message.actionCreators.sendMessage("Couldn't get trending items.", { error: true }))];
                        case 4:
                            _e.sent();
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            }),
            utils_1.takeEvery(toggleItemState, function _(item) {
                var _a, doneItems, todoItems, done;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, selectState()];
                        case 1:
                            _a = _b.sent(), doneItems = _a.doneItems, todoItems = _a.todoItems;
                            return [4 /*yield*/, effects_1.put(removeItem(item))];
                        case 2:
                            _b.sent();
                            done = !item_1.include(doneItems, item);
                            return [4 /*yield*/, effects_1.put(setItems({
                                    done: done,
                                    items: item_1.addItemToItems(done ? doneItems : todoItems, options.onToggleTaskState(item)),
                                }))];
                        case 3:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            }),
            utils_1.takeEvery(removeItem, function _(item) {
                var _a, doneItems, todoItems, done;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, selectState()];
                        case 1:
                            _a = _b.sent(), doneItems = _a.doneItems, todoItems = _a.todoItems;
                            done = item_1.include(doneItems, item);
                            return [4 /*yield*/, effects_1.put(setItems({
                                    done: done,
                                    items: item_1.removeItemFromItems(done ? doneItems : todoItems, item.id),
                                }))];
                        case 2:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            }),
            utils_1.takeEvery(setItems, function _(_a) {
                var done = _a.done, items = _a.items;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, effects_1.call(repository.state(done).set, items)];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            }),
        ],
        selectState: selectState,
        storeInitializer: function (store) {
            repository.onUpdate(function () { return store.dispatch(getItems.started(null)); });
        },
    };
}
exports.default = createItemsDuck;



//////////////////
// WEBPACK FOOTER
// ./src/redux/items.ts
// module id = 87
// module chunks = 0